import actions from "./actions";

const initState = {
  deviceTransactions: null,
};

export default function deviceReducer(state = initState, action) {
  switch (action.type) {
    case actions.FETCH_DEVICES_TRANSACTION_SUCCESS:
      return {
        ...state,
        deviceTransactions: action.deviceTransactions,
      };
    default:
      return state;
  }
}
